module.exports = __webpack_public_path__ + "static/img-slide-4-4774422a1bfc6468a305419f6672d95c.png";